import React, {Component} from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions';

class Toast extends Component {

  goToLocation = (loc) => {
    this.props.selecionaToastAlerta({ coordenadas: loc });
  }

  render() {
    return (
        <div onClick={ () => this.goToLocation(this.props.infos.localizacao) }>
            <div style={{ display: "flex", alignItems: "baseline" }}>
                <div>
                  {(() => {
                    switch(this.props.infos.tipo){
                      case "Roubo":
                        return(<img alt="" style={{ width: 24, height: 24 }} src={`${process.env.PUBLIC_URL}/images/toast/icon_roubo.svg`} />);
                      case "Drogas":
                        return(<img alt="" style={{ width: 24, height: 24 }} src={`${process.env.PUBLIC_URL}/images/toast/icon_drogas.svg`} />);
                      case "Emergência":
                        return(<img alt="" style={{ width: 24, height: 24 }} src={`${process.env.PUBLIC_URL}/images/toast/icon_emergencia.svg`} />);
                      case "Pessoa Suspeita":
                        return(<img alt="" style={{ width: 24, height: 24 }} src={`${process.env.PUBLIC_URL}/images/toast/icon_pessoasuspeita.svg`} />);
                      case "Veículo Suspeito":
                        return(<img alt="" style={{ width: 24, height: 24 }} src={`${process.env.PUBLIC_URL}/images/toast/icon_carrosuspeito.svg`} />);
                      case "Vandalismo":
                        return(<img alt="" style={{ width: 24, height: 24 }} src={`${process.env.PUBLIC_URL}/images/toast/icon_vandalismo.svg`} />);
                      default:
                        return(<img alt="" style={{ width: 24, height: 24 }} src={`${process.env.PUBLIC_URL}/images/toast/icon_emergencia.svg`} />);
                    }
                  })()}
                </div>
                <div style={{ marginLeft: 10 }}><p style={{ fontWeight:"bold" }} >{this.props.infos.tipo}</p></div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <p>{`${this.props.infos.usuario.nome} reportou um novo alerta!`}</p>
            </div>
        </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);
export default connect(null, mapDispatchToProps)(Toast);



// WEBPACK FOOTER //
// ./src/components/Toast.js